// Borrow Money
export const BORROW_MONEY_ID = 'borrow-money';
export const BORROW_MONEY_NAME = 'Borrow Money';
export const INITIAL_BORROW_MONEY = {
    id: BORROW_MONEY_ID,
    name: BORROW_MONEY_NAME,
};

// Pay Loan
export const PAY_LOAN_ID = 'pay-loan';
export const PAY_LOAN_NAME = 'Pay Loan';
export const INITIAL_PAY_LOAN = {
    id: PAY_LOAN_ID,
    name: PAY_LOAN_NAME,
};

// Raise Taxes
export const RAISE_TAXES_ID = 'raise-taxes';
export const RAISE_TAXES_NAME = 'Raise Taxes';
export const INITIAL_RAISE_TAXES = {
    id: RAISE_TAXES_ID,
    name: RAISE_TAXES_NAME,
};